import { useMemo } from 'react'
import { isEmojiOnlyMessage, messageHasEmoji } from '@/utils/messageEmojiText'
import { messageHasMention, splitMessageByMention } from '@/utils/messageMentionText'
import { buildMentionTargetLookup } from '@/utils/resolveMentionTarget'
import styles from '../UserChatBubble/index.module.scss'

export function useUserMessageTextModel({ text, className = '', mentionMembers = [], mentionAgents = [] }) {
  const emojiOnly = useMemo(() => isEmojiOnlyMessage(text), [text])
  const hasMention = useMemo(() => messageHasMention(text), [text])
  const mentionSegments = useMemo(() => (hasMention ? splitMessageByMention(text) : []), [hasMention, text])
  const mentionLookup = useMemo(
    () => buildMentionTargetLookup({ members: mentionMembers, agents: mentionAgents }),
    [mentionMembers, mentionAgents],
  )
  const hasMentionRoster = mentionMembers.length > 0 || mentionAgents.length > 0
  const textClassName = [styles.text, emojiOnly ? styles.textEmojiOnly : null, className].filter(Boolean).join(' ')
  const hasEmoji = messageHasEmoji(text)

  return { text, emojiOnly, hasMention, mentionSegments, mentionLookup, hasMentionRoster, textClassName, hasEmoji }
}
